import PaymentTypeServices from "@/services/PaymentTypeServices.js";

export default {
  getPaymentTypeDetails: PaymentTypeServices.getDetails,
  getPaymentTypeList: PaymentTypeServices.getList,
  postPaymentType: PaymentTypeServices.postData,
  putPaymentType: PaymentTypeServices.putData
}